import { ReactElement } from "react";
import classNames from "classnames";
import {
	Anchor,
	Icon,
	FontIconName,
	SvgIconValue
} from "client/Components";
import { setTrackingId } from "client/Misc/utils";
import styles from "./MenuItem.module.less";
import { AiAssistantAvatar } from "client/Features/ChatAssistant/AiAssistantAvatar";
import { never } from "client_legacy/ndaw/errors";

export type MenuItemIconValue = {
	kind: "icon-value";
	value: FontIconName | SvgIconValue;
} | {
	kind: "ai-assistant";
	url: string | null;
};

export type MenuItemProps = {
	icon: MenuItemIconValue;
	onClick: () => void;
	isActive?: boolean;
	count?: number;
	trackingId?: string;
};

export const MenuItem = (props: MenuItemProps): ReactElement => {
	const {
		icon,
		isActive,
		onClick,
		count = 0,
		trackingId,
	} = props;

	return (
		<li
			{...setTrackingId(trackingId)}
			className={styles.root}
		>
			<Anchor
				trackingId="link"
				onClick={() => onClick()}
				className={classNames(
					styles.link,
					{ [styles.link_active]: isActive }
				)}
			>
				<div className={styles.container}>
					{count > 0 && (
						<div className={styles.counterWrapper}>
							<UnreadCounter count={count} />
						</div>
					)}
					<MenuItemIcon icon={icon} />
				</div>
			</Anchor>
		</li>
	);
};
MenuItem.displayName="MenuItem";

type MenuItemIconProps = {
	icon: MenuItemIconValue;
};

const MenuItemIcon = (props: MenuItemIconProps) => {
	const { icon } = props;

	switch (icon.kind) {
		case "icon-value":
			return (
				<Icon value={icon.value} />
			);
		case "ai-assistant":
			return (
				<AiAssistantAvatar
					trackingId="ai-assistant-avatar"
					imageUrl={icon.url}
					size="x-small"
				/>
			);
		default:
			never(icon);
	}
};
MenuItemIcon.displayName = "MenuItemIcon";

type UnreadCounterProps = {
	count: number;
};

const UnreadCounter = (props: UnreadCounterProps): ReactElement => {
	const {
		count
	} = props;

	return (
		<span
			{...setTrackingId("counter")}
			className={styles.counter}
		>
			{count}
		</span>
	);
};
UnreadCounter.displayName="UnreadCounter";